import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { BrandModel } from '@app/models/Reviews/BrandModel';
import { IReviewAppRoute } from '@app/components/Reviews/ReviewsApp/routing';
import { ModelModel } from '@app/models/Reviews/ModelModel';
import { RootState } from '../store';
import { ReviewModel } from '@app/models/Reviews/ReviewModel';

interface IStateData {
  brands?: BrandModel[];
  slug?: string[];
  route?: IReviewAppRoute;
  brand?: BrandModel;
  model?: ModelModel;
  models: ModelModel[];
  modelsTotal: number;
  modelsHidden: ModelModel[];
  modelReviews: ReviewModel[];
  modelReviewsTotal: number;
  modelReviewsHidden: ReviewModel[];
}

interface IState {
  data: IStateData;
}

const initialState: IState = {
  data: {
    brands: [],
    slug: [],
    route: null,
    brand: null,
    model: null,
    models: [],
    modelsTotal: 0,
    modelsHidden: [],
    modelReviews: [],
    modelReviewsTotal: 0,
    modelReviewsHidden: [],
  },
};

export const applautReviewsSlice = createSlice({
  name: 'applautReviews',
  initialState,
  reducers: {
    setReviewsData: (state, action: PayloadAction<IStateData>) => {
      state.data = { ...action.payload };
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.applautReviews,
      };
    },
  },
});

export const { setReviewsData } = applautReviewsSlice.actions;

export const selectApplautReviewsData = (state: RootState) => state.applautReviews.data;

export const applautReviewsReducer = applautReviewsSlice.reducer;
